import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DotsWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Dot = styled.div<{ $isActive: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;

  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.yellow.lighterYellow : 'none'};

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid
      ${({ theme, $isActive }) =>
        $isActive ? theme.colors.yellow.darkYellow : theme.colors.neutral.lavender};
    background-color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.yellow.primary : 'white'};
  }
`;
